import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { PolygonRenderContribution } from "./contributions/constants";

import { DefaultCanvasPolygonRender } from "./polygon-render";

import { GraphicRender, PolygonRender } from "./symbol";

const loadedPolygonModuleContexts = new WeakSet;

export function bindPolygonRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedPolygonModuleContexts, bind) || (bind(PolygonRender).toDynamicValue((({container: container}) => new DefaultCanvasPolygonRender(createContributionProvider(PolygonRenderContribution, container)))).inSingletonScope(), 
    bind(GraphicRender).toService(PolygonRender), bind(PolygonRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, PolygonRenderContribution));
}

export const polygonModule = bindPolygonRenderModule;
//# sourceMappingURL=polygon-module.js.map
